<template>
    <el-dialog v-dialogDrag class="dialog" width="1080px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                系统初始化
            </div>
        </div>
        <div class="dialog_body">
            <el-form ref="formData" v-loading="loading"  label-width="120px">
                <el-tabs style="padding: 0 20px" v-model="activeName">
                <el-tab-pane name="a1">
                    <span slot="label">组织机构</span>
                    <div style="text-align: left">
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check01_01" :true-label="1" :false-label="0" border>组织机构
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check01_02" :true-label="1" :false-label="0" border>岗位设置
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check01_03" :true-label="1" :false-label="0" border>系统用户
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check01_04" :true-label="1" :false-label="0" border>公司员工
                            </el-checkbox>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="a2">
                    <span slot="label">供应商管理</span>
                    <div style="text-align: left">
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check02_01" :true-label="1" :false-label="0" border>供应商基本信息
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check02_02" :true-label="1" :false-label="0" border>供应商评分
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check02_03" :true-label="1" :false-label="0" border>供应商考核
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check02_04" :true-label="1" :false-label="0" border>供应商变更
                            </el-checkbox>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="a3">
                    <span slot="label">客户管理</span>
                    <div style="text-align: left">
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check03_01" :true-label="1" :false-label="0" border>客户基本信息
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check03_02" :true-label="1" :false-label="0" border>客户信息变更
                            </el-checkbox>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="a4">
                    <span slot="label">项目管理</span>
                    <div style="text-align: left">
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check04_01" :true-label="1" :false-label="0" border>项目基本信息
                            </el-checkbox>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="a5">
                    <span slot="label">物资信息</span>
                    <div style="text-align: left">
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check05_01" :true-label="1" :false-label="0" border>物资分类
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check05_02" :true-label="1" :false-label="0" border>物资计量单位
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check05_03" :true-label="1" :false-label="0" border>物资基础信息
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check05_04" :true-label="1" :false-label="0" border>物资库存信息
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check05_05" :true-label="1" :false-label="0" border>呆料设置信息
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check05_06" :true-label="1" :false-label="0" border>预警设置信息
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check05_07" :true-label="1" :false-label="0" border>物资期初信息
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check05_08" :true-label="1" :false-label="0" border>月结账信息
                            </el-checkbox>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="a6">
                    <span slot="label">采购管理</span>
                    <div style="text-align: left">
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check06_01" :true-label="1" :false-label="0" border>采购相关单据
                            </el-checkbox>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="a7">
                    <span slot="label">物资仓库管理</span>
                    <div style="text-align: left">
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check07_01" :true-label="1" :false-label="0" border>仓库设置信息
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check07_02" :true-label="1" :false-label="0" border>库位设置信息
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check07_03" :true-label="1" :false-label="0" border>物资单据
                            </el-checkbox>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="a8">
                    <span slot="label">销售管理</span>
                    <div style="text-align: left">
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check08_01" :true-label="1" :false-label="0" border>销售成本设置
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check08_02" :true-label="1" :false-label="0" border>销售相关单据
                            </el-checkbox>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="a9">
                    <span slot="label">财务管理</span>
                    <div style="text-align: left">
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check09_01" :true-label="1" :false-label="0" border>会计科目
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check09_02" :true-label="1" :false-label="0" border>费用设置信息
                            </el-checkbox>
                        </div>
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check09_03" :true-label="1" :false-label="0" border>财务相关单据
                            </el-checkbox>
                        </div>
                    </div>

                </el-tab-pane>

                <el-tab-pane name="a10">
                    <span slot="label">其他</span>
                    <div style="text-align: left">
                        <div style="padding-left: 20px;padding-bottom: 10px;margin-top:10px">
                            <el-checkbox v-model="check10_01" :true-label="1" :false-label="0" border>站内信
                            </el-checkbox>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            </el-form>
            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">初始化</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {},
        data() {
            return {
                activeName: "a1",
                dialoading: this.loading,
                check01_01:"0",
                check01_02:"0",
                check01_03:"0",
                check01_04:"0",

                check02_01:"0",
                check02_02:"0",
                check02_03:"0",
                check02_04:"0",

                check03_01:"0",
                check03_02:"0",

                check04_01:"0",

                check05_01:"0",
                check05_02:"0",
                check05_03:"0",
                check05_04:"0",
                check05_05:"0",
                check05_06:"0",
                check05_07:"0",
                check05_08:"0",

                check06_01:"0",

                check07_01:"0",
                check07_02:"0",
                check07_03:"0",
                check07_04:"0",

                check08_01:"0",
                check08_02:"0",
                check08_03:"0",
                check08_04:"0",

                check09_01:"0",
                check09_02:"0",
                check09_03:"0",
                check09_04:"0",

                check10_01:"0",
                check10_02:"0",
                check10_03:"0",
                check10_04:"0",
                dialogVisible: true,
                formLabelWidth: '80px'
            };
        },
        mounted() {
        },
        methods: {
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async submitForm() {
                let formData = {
                    check01_01:this.check01_01,
                    check01_02:this.check01_02,
                    check01_03:this.check01_03,
                    check01_04:this.check01_04,

                    check02_01:this.check02_01,
                    check02_02:this.check02_02,
                    check02_03:this.check02_03,
                    check02_04:this.check02_04,

                    check03_01:this.check03_01,
                    check03_02:this.check03_02,

                    check04_01:this.check01_01,

                    check05_01:this.check05_01,
                    check05_02:this.check05_02,
                    check05_03:this.check05_03,
                    check05_04:this.check05_04,
                    check05_05:this.check05_05,
                    check05_06:this.check05_06,
                    check05_07:this.check05_07,
                    check05_08:this.check05_08,

                    check06_01:this.check06_01,

                    check07_01:this.check07_01,
                    check07_02:this.check07_02,
                    check07_03:this.check07_03,

                    check08_01:this.check08_01,
                    check08_02:this.check08_02,

                    check09_01:this.check09_01,
                    check09_02:this.check09_02,
                    check09_03:this.check09_03,

                    check10_01:this.check10_01
                }

                this.$emit('submitForm', formData);
            },
        }
    }
</script>

